import {AttributeLink, AttributeSetup} from '@acng/frontend-stargazer';
import {Watch} from '@acng/frontend-relativity';

import {ctxAmateur} from '../../amateurPool/context/amateur.js';
import {SetGalleryCount} from '../../amateurPool/service/gallery-count.js';
import {compile} from '../service/template.js';

/**
 * Use {@link SetGalleryCount} with type "movie" to display the count
 * of movies of the {@link ctxAmateur}.
 *
 * Use {@link compile} to remove the element if the "moviePool" feature is hidden.
 *
 * @group DOM Attribute
 */
export const SEDCARD_MOVIE_COUNT = 'data-sedcard-movie-count';

AttributeSetup(SEDCARD_MOVIE_COUNT, (name) => {
  const watch = Watch(`[${name}]`, ctxAmateur);
  const update = SetGalleryCount('movie');

  AttributeLink(name, () => (element) => {
    watch(element, update);
  });

  return compile;
});
